import { Reveal } from "./Reveal";
import { MANIFESTO, IMAGES, BRAND } from "@/data";

export default function Manifesto() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="py-24 md:py-36"
      style={{ backgroundColor: "var(--bg-primary)" }}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <p
              className="text-sm tracking-[0.28em] uppercase mb-6"
              style={{ color: "var(--rose-mocha-deep)" }}
            >
              The Approach
            </p>
            <h2
              className="font-serif text-4xl md:text-5xl leading-tight tracking-tight mb-10"
              style={{ color: "var(--text-primary)" }}
            >
              A calmer way to run your business.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div
              className="img-zoom-wrap rounded-2xl overflow-hidden aspect-[6/5]"
              style={{ border: "1px solid var(--border-light)" }}
            >
              <img
                src={IMAGES.aboutPortrait}
                alt={`${BRAND.founder}, ${BRAND.founderRole}`}
                className="w-full h-full object-cover"
                style={{ objectPosition: "50% 18%" }}
              />
            </div>
            <div className="mt-5 flex items-baseline justify-between gap-4">
              <p
                className="font-serif text-xl md:text-2xl tracking-tight"
                style={{ color: "var(--text-primary)" }}
              >
                {BRAND.founder}
              </p>
              <p
                className="text-xs tracking-[0.2em] uppercase text-right"
                style={{ color: "var(--rose-mocha-deep)" }}
              >
                {BRAND.founderRole}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center gap-12">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.num} delay={i * 0.1}>
              <div
                className="flex gap-6 md:gap-10 pb-10"
                style={{
                  borderBottom:
                    i < MANIFESTO.length - 1
                      ? "1px solid var(--border-light)"
                      : "none",
                }}
              >
                <span
                  className="font-serif text-5xl md:text-7xl leading-none"
                  style={{ color: "var(--accent-gold)" }}
                >
                  {m.num}
                </span>
                <div>
                  <h3
                    className="font-serif text-2xl md:text-3xl mb-3 tracking-tight"
                    style={{ color: "var(--text-primary)" }}
                  >
                    {m.title}
                  </h3>
                  <p
                    className="text-base md:text-lg leading-relaxed"
                    style={{ color: "var(--text-secondary)" }}
                  >
                    {m.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
